/**
 * 파일 끌어다 놓기 — AI 에이전트 입력 창에 떨어뜨린 것을 첨부할 파일로 고른다.
 *
 * 첨부 형식 목록은 **여기 한 곳**이다. 파일 선택(CaseSourceBar)과 끌어다 놓기가 같은 목록을 봐야
 * "고르면 되는데 끌어 놓으면 안 된다" 가 생기지 않는다. 형식의 최종 판정은 여전히 서버
 * (harness/attachments.js)이고, 여기서는 올리기 전에 사유를 알려 주려고 먼저 거른다.
 */

/** 파일 선택 input 의 accept 와 같다 */
export const ATTACH_ACCEPT = '.txt,.sql,.log,.md,.csv,.json,.png,.jpg,.jpeg,.gif,.webp,.pdf,.pptx';

const extsOf = (accept) => String(accept || '')
  .split(',')
  .map((s) => s.trim().toLowerCase())
  .filter(Boolean);

/** 끌고 있는 것이 파일인가 — 입력란 안에서 글자를 끌어 옮기는 것까지 가로채면 안 된다 */
export function hasDraggedFiles(dataTransfer) {
  const types = dataTransfer && dataTransfer.types;
  if (!types) return false;
  if (typeof types.includes === 'function') return types.includes('Files');
  if (typeof types.contains === 'function') return types.contains('Files');
  return Array.from(types).includes('Files');
}

/**
 * 떨어뜨린 것을 나눈다. drop 이벤트 안에서 **바로** 불러야 한다(이벤트가 끝나면 항목을 못 읽는다).
 * @returns {{ files: File[], rejected: string[], folders: number }}
 */
export function collectDroppedFiles(dataTransfer, accept = ATTACH_ACCEPT) {
  const exts = extsOf(accept);
  const accepted = (name) => {
    const n = String(name || '').toLowerCase();
    return exts.some((ext) => n.endsWith(ext));
  };
  const files = [];
  const rejected = [];
  let folders = 0;
  const take = (file) => {
    if (!file) return;
    if (accepted(file.name)) files.push(file);
    else rejected.push(file.name);
  };

  const items = dataTransfer && dataTransfer.items ? Array.from(dataTransfer.items) : [];
  if (items.length) {
    for (const item of items) {
      if (item.kind !== 'file') continue;
      // 폴더는 getAsFile 이 크기 0 짜리 가짜 파일을 주기도 한다 — 항목 종류로 먼저 가른다
      const entry = typeof item.webkitGetAsEntry === 'function' ? item.webkitGetAsEntry() : null;
      if (entry && entry.isDirectory) {
        folders += 1;
        continue;
      }
      take(item.getAsFile());
    }
  } else {
    Array.from((dataTransfer && dataTransfer.files) || []).forEach(take);
  }
  return { files, rejected, folders };
}
